/** Numeric helpers shared by the trade pages (ported from the old record-utils). */

export function parseQuantity(value: string | number | null | undefined): number {
  const normalized = `${value ?? ''}`.replace(/,/g, '').trim();
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

/** Keeps a free-text quantity input numeric while the user types (digits + one dot). */
export function normalizeQuantityInput(value: string | null | undefined): string {
  const digits = `${value ?? ''}`.replace(/[^\d.]/g, '');
  const [head, ...rest] = digits.split('.');
  return rest.length > 0 ? `${head}.${rest.join('')}` : head;
}

export function formatQuantity(value: number | string | null | undefined): string {
  const parsed = parseQuantity(value);
  return parsed.toLocaleString('th-TH', {maximumFractionDigits: 2});
}

/** "1,000 กิโลกรัม" — an empty unit collapses to the number only. */
export function formatQuantityWithUnit(
  value: number | string | null | undefined,
  unit: string | null | undefined
): string {
  return `${formatQuantity(value)} ${unit ?? ''}`.trim();
}

/** Today as `yyyy-MM-dd`, the format the datepicker and the backend both use. */
export function todayIsoDate(): string {
  const now = new Date();
  const month = `${now.getMonth() + 1}`.padStart(2, '0');
  const day = `${now.getDate()}`.padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

/**
 * "(น้อยหน่า 1 + น้อยหย่าเบอร์ 1 550)" — where a sale-offer line was pulled
 * from. Empty for a line drawn from a single pool, which needs no breakdown.
 */
export function offerComponentsBreakdown(
  components: Array<{productName?: string; quantity?: number}> | null | undefined
): string {
  const lines = components ?? [];
  if (lines.length < 2) {
    return '';
  }
  return `(${lines.map((item) => `${item.productName ?? '-'} ${formatQuantity(item.quantity)}`).join(' + ')})`;
}
